@use "variables" as *;

.container {
  padding: $spacing-s !important;
}

.dragIcon {
  font-size: $fontSize-ml !important;
  align-self: center;
  margin-right: $spacing-m;
}

.imageStack {
  margin-right: $spacing-m;
}

.image {
  display: flex;
  height: 50px;
  width: 50px;
}

.defaultIcon {
  display: flex;
  height: 50px;
  width: 50px;
  align-items: center;
  justify-content: center;
  border-radius: 16px !important;
}

.inactiveCard {
  font-size: $fontSize-xxs;
  padding: 0 $spacing-xs;
  font-weight: bold;
}

.rightContainer {
  height: 100%;
  width: 100%;
  margin-right: $spacing-s;
}

.name {
  font-size: $fontSize-s;
  font-weight: bold;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.brand {
  font-size: $fontSize-s;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-weight: normal;
}

.profile {
  white-space: pre-wrap;
  font-size: $fontSize-xxs;
  font-weight: normal;
  margin-bottom: $spacing-s;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.hoverButton {
  width: 30px;
  height: 30px;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.25);
}
